import { jsx as _jsx } from "react/jsx-runtime";
import { useRef, useState, useLayoutEffect, useEffect } from "react";
import { Transition } from "@headlessui/react";
export function Tooltip({ description, position }) {
    const tooltipRef = useRef(null);
    const [adjustedPosition, setAdjustedPosition] = useState({
        x: -9999,
        y: -9999
    });
    const [currentDescription, setCurrentDescription] = useState(null);
    useEffect(()=>{
        if (description) {
            setCurrentDescription(description);
        }
    }, [
        description
    ]);
    useLayoutEffect(()=>{
        if (tooltipRef.current && currentDescription) {
            const { offsetWidth, offsetHeight } = tooltipRef.current;
            const { innerWidth, innerHeight } = window;
            const margin = 15;
            // Default position: top-right of the cursor
            let newX = position.x + margin;
            let newY = position.y - margin;
            // Adjust if it goes off the RIGHT edge
            if (newX + offsetWidth > innerWidth) {
                newX = position.x - offsetWidth - margin;
            }
            // Adjust if it goes off the BOTTOM edge
            if (newY + offsetHeight > innerHeight) {
                newY = position.y - offsetHeight - margin;
            }
            // Adjust if it goes off the LEFT edge
            if (newX < 0) {
                newX = margin;
            }
            // Adjust if it goes off the TOP edge
            if (newY < 0) {
                newY = margin;
            }
            setAdjustedPosition({
                x: newX,
                y: newY
            });
        }
    }, [
        position,
        currentDescription
    ]);
    return /*#__PURE__*/ _jsx(Transition, {
        show: !!description,
        enter: "transition-opacity ease-in-out duration-200",
        enterFrom: "opacity-0",
        enterTo: "opacity-100",
        leave: "transition-opacity ease-in-out duration-200",
        leaveFrom: "opacity-100",
        leaveTo: "opacity-0",
        afterLeave: ()=>{
            setCurrentDescription(null);
        },
        children: /*#__PURE__*/ _jsx("div", {
            ref: tooltipRef,
            className: "flex fixed z-10 bg-white rounded-lg shadow-lg border border-gray-200 p-4 min-w-64 max-w-[500px] pointer-events-none",
            style: {
                left: adjustedPosition.x,
                top: adjustedPosition.y
            },
            children: /*#__PURE__*/ _jsx("div", {
                className: "space-y-3",
                children: /*#__PURE__*/ _jsx("div", {
                    children: currentDescription
                })
            })
        })
    });
}
